/* global exportToFileUrl */

import React, { useState, useEffect, Fragment } from 'react';

import AuditLogsTableRow from './AuditLogsTableRow';

import { collectSortObject, defaultSortIconClass, descSortIconClass } from 'Helpers/tableService';
import { combinePaginationUrl } from 'Helpers/urlService';

import Button from 'CommonComponents/Button';
import CheckboxInput from 'CommonComponents/CheckboxInput';
import DatePickerField from 'CommonComponents/DatePickerField';
import PaginationInfo from 'CommonComponents/PaginationInfo';
import TableFilterModal from 'CommonComponents/TableFilterModal';
import TablePagination from 'CommonComponents/TablePagination';
import TableSortHeaderCell from 'CommonComponents/TableSortHeaderCell';

import FileExportIcon from 'Assets/icons/file-export.svg';

export default function AuditLogsIndexTable(props) {
    const [activityLogs, setActivityLogs] = useState([]);
    const [perPage, setPerPage] = useState(10);
    const [page, setPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [to, setTo] = useState(1);
    const [from, setFrom] = useState(1);
    const [total, setTotal] = useState(1);
    const [sort, setSort] = useState(null);

    const [budgetId, setBudgetId] = useState('');

    const ACTION_LABELS = {
        section_visibility_changed: () => $t('Visibility changed'),
        modules_changed: () => $t('Modules changed'),
        user_activity_downloaded: () => $t('User activity downloaded'),
    };
    const actionLabel = (actionName) => (ACTION_LABELS[actionName] ? ACTION_LABELS[actionName]() : actionName);
    const [showFilters, setShowFilters] = useState(false);
    const [filters, setFilters] = useState({
        users: {},
        types: {},
        dates: {
            from: props.fromDate,
            to: props.toDate,
        },
        descriptions: {},
    });
    const [mounted, setMounted] = useState(false);
    const [displayedGroups, setDisplayedGroups] = useState({});

    const [sorts, setSorts] = useState({
        description: {
            by: 'description',
            order: null,
            icon: defaultSortIconClass,
        },
        created_at: {
            by: 'created_at',
            order: 'desc',
            icon: descSortIconClass,
        },
        subject_type: {
            by: 'subject_type',
            order: null,
            icon: defaultSortIconClass,
        },
        causer: {
            by: 'causer',
            order: null,
            icon: defaultSortIconClass,
        },
    });

    useEffect(() => {
        if (mounted) {
            const url = combineFetchUrl(1, null, null, budgetId);
            fetchLogs(url);
        }
    }, [budgetId]);

    const clickSorts = (by) => {
        let sortBy = by;
        let { sortsObject, sortOrder } = collectSortObject(sorts, sortBy);
        const obj = { by: sortBy, order: sortOrder };

        setSort(obj);
        setSorts(sortsObject);
        const url = combineFetchUrl(null, null, obj);

        fetchLogs(url);
    };

    useEffect(() => {
        const fData = JSON.parse(JSON.stringify(filters));
        props.users.forEach((user) => {
            fData.users[user.id] = true;
        });
        props.types.forEach((type) => {
            fData.types[type] = true;
        });
        props.descriptions.forEach((item) => {
            fData.descriptions[item] = true;
        });

        setFilters(fData);
        $(document).on('click', function (e) {
            if ($(e.target).closest('#filters-dropdown').length === 0) {
                setShowFilters(false);
            }
        });
        fetchLogs(null, fData);
        setMounted(true);
    }, []);

    const defaultUrl = combinePaginationUrl(props.fetchUrl, perPage);

    const combineFetchUrl = (p = null, pp = null, s = null, budgetId = null) => {
        let dataUrl = combinePaginationUrl(props.fetchUrl, pp || perPage, p || page, s || sort);
        let url = new URL(dataUrl);
        let params = new URLSearchParams(url.search);

        if (budgetId) {
            params.set('budget_id', '' + budgetId);
        } else {
            params.delete('budget_id');
        }

        dataUrl = url.origin + url.pathname;
        if (params.toString()) {
            dataUrl += '?' + params.toString();
        }

        return dataUrl;
    };

    const fetchLogs = (url = null, filtersObject = null) => {
        const fetchUrl = url || defaultUrl;

        const fData = {
            filters: {
                users: [],
                types: [],
                descriptions: [],
                dates: {
                    from: props.fromDate,
                    to: props.toDate,
                },
            },
        };
        const _filters = filtersObject || filters;

        Object.keys(_filters.users).forEach((userId) => {
            if (_filters.users[userId]) {
                if (userId) {
                    fData.filters.users.push(userId);
                } else {
                    fData.filters.users.push(null);
                }
            }
        });
        Object.keys(_filters.types).forEach((type) => {
            if (_filters.types[type]) {
                fData.filters.types.push(type);
            }
        });

        Object.keys(_filters.descriptions).forEach((desc) => {
            if (_filters.descriptions[desc]) {
                fData.filters.descriptions.push(desc);
            }
        });

        if (_filters?.dates?.from) {
            fData.filters.dates.from = _filters.dates.from;
        }
        if (_filters?.dates?.to) {
            fData.filters.dates.to = _filters.dates.to;
        }

        axios
            .post(fetchUrl, fData)
            .then((res) => {
                const { data, meta } = res.data;
                setActivityLogs(data);
                setTo(meta.to);
                setFrom(meta.from);
                setTotal(meta.total);
                setLastPage(meta.last_page);

                const visible = JSON.parse(JSON.stringify(displayedGroups));
                data.forEach((item) => {
                    if (!!item.batch_uuid && item.groups.length > 0) {
                        const uuid = item.batch_uuid;
                        visible[uuid] = visible[uuid] || false;
                    }
                });
                setDisplayedGroups(visible);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const toggleVisible = (uuid) => {
        const visible = JSON.parse(JSON.stringify(displayedGroups));
        if (!!uuid && uuid in visible) {
            visible[uuid] = !visible[uuid];
        }
        setDisplayedGroups(visible);
    };

    const pageChange = (data) => {
        const url = combineFetchUrl(data.selected + 1);
        setPage(+data.selected + 1);
        fetchLogs(url);
    };

    const budgetChange = (e) => {
        setBudgetId(e.target.value);
    };

    const selectAll = (e, group, value = true) => {
        const _filters = JSON.parse(JSON.stringify(filters));
        Object.keys(_filters[group]).forEach((key) => {
            _filters[group][key] = value;
        });

        setFilters(_filters);
    };

    const toggleFilter = (group, key) => {
        const _filters = JSON.parse(JSON.stringify(filters));
        _filters[group][key] = !_filters[group][key];

        setFilters(_filters);
    };

    const applyFilters = (e) => {
        setShowFilters(false);
        fetchLogs();
    };

    const filterDateChange = (key, value) => {
        const fData = JSON.parse(JSON.stringify(filters));

        if (key === 'from_date') {
            fData.dates.from = value;
        }
        if (key === 'to_date') {
            fData.dates.to = value;
        }

        setFilters(fData);
    };

    return (
        <>
            <div className="table__card">
                <div className="tw-flex tw-items-start tw-justify-between tw-mb-6">
                    <div>
                        <h4 className="table__header">{$t('Activity Logs')}</h4>
                        <div className="tw-flex tw-items-center tw-space-x-3">
                            <PaginationInfo to={to} from={from} total={total} />
                            <TablePagination lastPage={lastPage} pageChange={pageChange} />
                        </div>
                    </div>
                    <div className="tw-flex tw-justify-end tw-gap-x-2">
                        <label className="tw-inline-flex tw-items-center tw-gap-x-1.5 tw-text-xs tw-text-charcoal-75">
                            {$t('Budgets')}
                            <select
                                className="tw-h-8 tw-bg-grey tw-font-semibold tw-text-charcoal tw-rounded-full tw-pl-5 tw-pr-7 tw-ring-0 tw-border-0 focus:tw-ring-0 focus:tw-border-0"
                                onChange={budgetChange}
                            >
                                <option value={''}>{$t('All budgets')}</option>
                                {props.budgets.map((budget) => {
                                    return (
                                        <option value={budget.id} key={budget.id}>
                                            {budget.name}
                                        </option>
                                    );
                                })}
                            </select>
                        </label>
                        <Button variant="primary" as="a" href={exportToFileUrl} data-action="navigate">
                            <FileExportIcon className="tw-w-3 tw-h-3" />
                            {$t('Export to file')}
                        </Button>
                    </div>
                </div>
                <div className="inbud-table_wrapper">
                    <table className="inbud-table">
                        <thead>
                            <tr>
                                <th scope="col" className="tw-cursor-pointer tw-min-w-32">
                                    <div className="tw-flex tw-justify-between">
                                        <div
                                            onClick={() => {
                                                clickSorts('causer');
                                            }}
                                        >
                                            <TableSortHeaderCell asc={sorts.causer.order === 'asc'} desc={sorts.causer.order === 'desc'}>
                                                {$t('User')}
                                            </TableSortHeaderCell>
                                        </div>
                                        <TableFilterModal onApply={applyFilters} customIconStyle={'xs'}>
                                            <div className="tw-space-y-4 tw-min-w-96">
                                                <div>
                                                    <div className="tw-flex tw-justify-between tw-items-center tw-mb-2">
                                                        <div className="tw-text-xs tw-text-charcoal">{$t('Users')}</div>
                                                        <div className="tw-space-x-2">
                                                            <button className="tw-text-xs tw-font-semibold tw-underline" onClick={(e) => selectAll(e, 'users')}>
                                                                {$t('Select all')}
                                                            </button>
                                                            <button
                                                                className="tw-text-xs tw-font-semibold tw-underline"
                                                                onClick={(e) => selectAll(e, 'users', false)}
                                                            >
                                                                {$t('Unselect all')}
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div className="tw-grid tw-grid-cols-3 tw-gap-2">
                                                        {props.users.map((user) => {
                                                            return (
                                                                <div key={`user_${user.id}`}>
                                                                    <CheckboxInput
                                                                        id={`user_${user.id}`}
                                                                        checked={filters.users[user.id]}
                                                                        label={`${user.first_name} ${user.last_name}`}
                                                                        onChange={() => toggleFilter('users', user.id)}
                                                                    />
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                            </div>
                                        </TableFilterModal>
                                    </div>
                                </th>
                                <th scope="col" className="tw-cursor-pointer tw-min-w-32">
                                    <div className="tw-flex tw-justify-between">
                                        <div
                                            onClick={() => {
                                                clickSorts('created_at');
                                            }}
                                        >
                                            <TableSortHeaderCell asc={sorts.created_at.order === 'asc'} desc={sorts.created_at.order === 'desc'}>
                                                {$t('Date')}
                                            </TableSortHeaderCell>
                                        </div>
                                        <TableFilterModal onApply={applyFilters} customIconStyle={'xs'}>
                                            <div className="text-base-tile-col [&_.react-datepicker-popper]:tw-z-20">
                                                <label className="tw-mt-1" htmlFor="logsFromdate">
                                                    {$t('Logs From Date')}
                                                </label>
                                                <div>
                                                    <DatePickerField
                                                        id="logsFromdate"
                                                        name="from_date"
                                                        className="tw-block tw-w-full tw-rounded-lg tw-text-sm !tw-bg-grey/25 -tw-my-1 tw-px-2 tw-py-1 tw-text-charcoal focus:tw-outline-0 form-control"
                                                        value={filters.dates.from}
                                                        valueFormat="yyyy-MM-dd"
                                                        dateFormat="yyyy-MM-dd"
                                                        required
                                                        onChange={filterDateChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="text-base-tile-col [&_.react-datepicker-popper]:tw-z-20">
                                                <label className="tw-mt-1" htmlFor="logsTodate">
                                                    {$t('Logs To Date')}
                                                </label>
                                                <div>
                                                    <DatePickerField
                                                        id="logsTodate"
                                                        name="to_date"
                                                        className="tw-block tw-w-full tw-rounded-lg tw-text-sm !tw-bg-grey/25 -tw-my-1 tw-px-2 tw-py-1 tw-text-charcoal focus:tw-outline-0 form-control"
                                                        value={filters.dates.to}
                                                        valueFormat="yyyy-MM-dd"
                                                        dateFormat="yyyy-MM-dd"
                                                        required
                                                        onChange={filterDateChange}
                                                    />
                                                </div>
                                            </div>
                                        </TableFilterModal>
                                    </div>
                                </th>
                                <th scope="col" className="tw-cursor-pointer tw-min-w-32">
                                    <div className="tw-flex tw-justify-between">
                                        <div
                                            onClick={() => {
                                                clickSorts('subject_type');
                                            }}
                                        >
                                            <TableSortHeaderCell asc={sorts.subject_type.order === 'asc'} desc={sorts.subject_type.order === 'desc'}>
                                                {$t('Type')}
                                            </TableSortHeaderCell>
                                        </div>
                                        <TableFilterModal onApply={applyFilters} customIconStyle={'xs'}>
                                            <div className="tw-space-y-4 tw-min-w-96">
                                                <div>
                                                    <div className="tw-flex tw-justify-between tw-items-center tw-mb-2">
                                                        <div className="tw-text-xs tw-text-charcoal">{$t('Type')}</div>
                                                        <div className="tw-space-x-2">
                                                            <button className="tw-text-xs tw-font-semibold tw-underline" onClick={(e) => selectAll(e, 'types')}>
                                                                {$t('Select all')}
                                                            </button>
                                                            <button
                                                                className="tw-text-xs tw-font-semibold tw-underline"
                                                                onClick={(e) => selectAll(e, 'types', false)}
                                                            >
                                                                {$t('Unselect all')}
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div className="tw-grid tw-grid-cols-3 tw-gap-2">
                                                        {Object.keys(filters.types).map((typeName) => {
                                                            return (
                                                                <div key={`type_${typeName}`}>
                                                                    <CheckboxInput
                                                                        id={`type_${typeName}`}
                                                                        checked={filters.types[typeName]}
                                                                        label={typeName}
                                                                        onChange={() => toggleFilter('types', typeName)}
                                                                    />
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                            </div>
                                        </TableFilterModal>
                                    </div>
                                </th>

                                <th scope="col" className="tw-cursor-pointer tw-min-w-32">
                                    <div className="tw-flex tw-justify-between">
                                        <div
                                            onClick={() => {
                                                clickSorts('description');
                                            }}
                                        >
                                            <TableSortHeaderCell asc={sorts.description.order === 'asc'} desc={sorts.description.order === 'desc'}>
                                                {$t('Action')}
                                            </TableSortHeaderCell>
                                        </div>
                                        <TableFilterModal onApply={applyFilters} customIconStyle={'xs'}>
                                            <div className="tw-space-y-4 tw-min-w-96">
                                                <div>
                                                    <div className="tw-flex tw-justify-between tw-items-center tw-mb-2">
                                                        <div className="tw-text-xs tw-text-charcoal">{$t('Action')}</div>
                                                        <div className="tw-space-x-2">
                                                            <button
                                                                className="tw-text-xs tw-font-semibold tw-underline"
                                                                onClick={(e) => selectAll(e, 'descriptions')}
                                                            >
                                                                {$t('Select all')}
                                                            </button>
                                                            <button
                                                                className="tw-text-xs tw-font-semibold tw-underline"
                                                                onClick={(e) => selectAll(e, 'descriptions', false)}
                                                            >
                                                                {$t('Unselect all')}
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div className="tw-grid tw-grid-cols-3 tw-gap-2">
                                                        {Object.keys(filters.descriptions).map((actionName) => {
                                                            return (
                                                                <div key={`type_${actionName}`}>
                                                                    <CheckboxInput
                                                                        id={`type_${actionName}`}
                                                                        checked={filters.descriptions[actionName]}
                                                                        label={actionLabel(actionName)}
                                                                        onChange={() => toggleFilter('descriptions', actionName)}
                                                                    />
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                            </div>
                                        </TableFilterModal>
                                    </div>
                                </th>
                                <th scope="col" className="tw-min-w-32">
                                    {$t('Location')}
                                </th>
                                <th scope="col" className="tw-min-w-32">
                                    {$t('Link')}
                                </th>
                                <th scope="col" className="tw-min-w-64 tw-max-w-64 tw-break-words">
                                    {$t('Previous Values')}
                                </th>
                                <th scope="col" className="tw-min-w-64 tw-max-w-64 tw-break-words">
                                    {$t('Current Values')}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {activityLogs.map((log) => {
                                const uuid = log.batch_uuid;
                                const groups = log.groups;

                                const visible = !!uuid && displayedGroups[uuid];
                                const canBeExpanded = !!uuid && groups.length > 0;

                                return (
                                    <Fragment key={log.id}>
                                        <AuditLogsTableRow
                                            log={log}
                                            expanded={visible}
                                            toggleVisible={toggleVisible}
                                            parent={true}
                                            canBeExpanded={canBeExpanded}
                                        />
                                        {canBeExpanded && visible && (
                                            <>
                                                {groups.map((groupItem) => {
                                                    return (
                                                        <AuditLogsTableRow
                                                            key={groupItem.id}
                                                            log={groupItem}
                                                            expandedOptionns={displayedGroups}
                                                            toggleVisible={toggleVisible}
                                                            parent={false}
                                                            expanded={false}
                                                            canBeExpanded={false}
                                                        />
                                                    );
                                                })}
                                            </>
                                        )}
                                    </Fragment>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}
